import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FollowTasksList } from '.';

import type { Task } from 'shared-types';

const FollowTasks = () => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const { data, loading } = useApiData({
    url: `admin/courses/${course.id}/tasks?include=answers&languageVersion=all`,
    onlyIf: Boolean(course.id)
  });

  const unreviewedTasks = ((data?.tasks as Task[]) || []).filter(
    (task) => task.unreviewedAnswers > 0
  );
  const unreviewedTasksIds = unreviewedTasks.map((task) => task.id);

  if (!course) return null;

  return (
    <>
      {unreviewedTasks.length ? (
        <div style={{ marginBottom: 20 }}>
          <FollowTasksList
            chapters={data?.chapters || []}
            courseSlug={course.slug}
            loading={loading}
            tasks={unreviewedTasks}
            title={messages.tasksAwaitingReview}
          />
        </div>
      ) : null}

      <FollowTasksList
        chapters={data?.chapters || []}
        courseSlug={course.slug}
        loading={loading}
        tasks={((data?.tasks as Task[]) || []).filter(
          (task) => !unreviewedTasksIds.includes(task.id)
        )}
        title={messages.tasks}
      />
    </>
  );
};

export default FollowTasks;
